import * as React from "react";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { IconButton, CircularProgress, Button } from "@mui/material";
import { memberProgrammeListings } from "src/DAL/Programme/Programme";
import { productListApi } from "src/DAL/member/member";
import {
  addPaymentPlanApi,
  detailPaymentPlanApi,
  editPaymentPlanApi,
} from "src/DAL/WebsitePages/paymentPlan";
import { page_detail_by_id } from "src/DAL/WebsitePages/websitepages";
import { s3baseUrl } from "src/config/config";
import { uploadImageOns3 } from "src/DAL/commonApi/commonApi";
import GeneralCkeditor from "src/components/GeneralCkeditor";
import MUIAutocomplete from "src/components/GeneralComponents/MUIAutocomplete";
import { website_active_plan_category_list_api } from "src/DAL/WebsitePages/WebPagePlanCategory";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const Input = styled("input")({
  display: "none",
});
export default function AddOrUpdatePaymentPlan() {
  const navigate = useNavigate();
  const classes = useStyles();
  const params = useParams();
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [groupsName, setGroupsName] = useState([]);
  const [file, setProfileImage] = useState();
  const [formType, setFormType] = useState("ADD");
  const [eventsName, setEventsName] = useState([]);
  const [moduleData, setModuleData] = useState({});
  const [oldImage, setOldImage] = useState();
  const [pageData, setPageData] = useState({});
  const module_actual_name = "payment_plans";

  const fileChangedHandler = async (e) => {
    const formData = new FormData();
    setIsLoading(true);
    formData.append("image", e.target.files[0]);
    formData.append("width", "823");
    formData.append("height", "363");
    const imageUpload = await uploadImageOns3(formData);
    if (imageUpload.code == 200) {
      setProfileImage(URL.createObjectURL(e.target.files[0]));
      setIsLoading(false);

      setInputs({
        ...inputs,
        ["plan_image"]: imageUpload.image_path,
      });
    } else {
      enqueueSnackbar(imageUpload.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  const urlPatternValidation = (URL) => {
    const regex = new RegExp(
      "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?",
    );
    return regex.test(URL);
  };
  const [planCategoryList, setPlanCategoryList] = useState([]);
  const [inputs, setInputs] = useState({
    plan_title: "",
    is_plan_free: true,
    plan_package: "",
    number_of_days: "",
    plan_button_text: "",
    active_campaign_tag_id: 0,
    active_campaign_list_id: 0,
    plan_status: true,
    user_type: "coach_user",
    short_description: "",
    detailed_description: "",
    benefit_description: "",
    plan_currency: "gbp",
    plan_price: 0,
    tax: 0,
    is_dont_show_full_amount: true,
    stripe_product_name: "",
    detail_button_text: "",
    video_url: "",
    video_description: "",
    payment_access: "onetime",
    plan_type: "week",
    time_period_interval: 0,
    trial_period_days: 0,
    initial_amount: 0,
    plan_order: 0,
    installment_amount: 0,
    product: "",
    is_basic_membership: false,
    plan_for: "Basic",
    programme: "",
    member: "",
    extra_coins: 0,
    is_new_user_created_for: true,
    first_and_next_recurring_days_diffrence: false,
    days_difference: 0,
    subscriber_count: 0,
    plan_image: {},
    plan_category_ids: [],
  });

  const ChangeCommissonAmount = () => {
    if (inputs.payment_access === "onetime") {
      setInputs((values) => ({
        ...values,
      }));
    } else {
      setInputs((values) => ({
        ...values,
      }));
    }
    return true;
  };

  const renderCurrency = () => {
    return (
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Plan Currency *</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          name="plan_currency"
          value={inputs.plan_currency}
          label="Plan currency"
          onChange={handleChange}
        >
          <MenuItem value="usd">Dollar</MenuItem>
          <MenuItem value="gbp">UK Pounds</MenuItem>
          <MenuItem value="eur">Euro</MenuItem>
        </Select>
      </FormControl>
    );
  };

  const productList = async () => {
    let result = await productListApi();
    if (result.code == 200) {
      setProducts(result.product);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const getPlanCategoryList = async () => {
    setIsLoading(true);
    const result = await website_active_plan_category_list_api();
    if (result.code === 200) {
      setPlanCategoryList(result.planCategories);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  const getProgrammes = async () => {
    const result = await memberProgrammeListings();
    if (result.code === 200) {
      let program_array = [];
      const resultProgramIds = result.program.map((item) => item._id);

      state.data?.program.forEach((item) => {
        if (resultProgramIds.includes(item.program_id)) {
          program_array.push(item.program_id);
        }
      });
      setGroupsName(program_array);

      productList();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (inputs.is_plan_free == false && inputs.payment_access == "recursion") {
    }
    if (
      urlPatternValidation(inputs.video_url) === false &&
      inputs.video_url !== ""
    ) {
      enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
      setIsLoading(false);
      return;
    }

    let programme_array = [];

    let group_object = {};
    groupsName.map((group) => {
      console.log(group, "groupgroup");
      group_object = {
        program_id: group,
      };
      programme_array.push(group_object);
    });
    let selected_event_array = [];

    let selected_event_object = {};
    eventsName.map((event) => {
      selected_event_object = {
        event_id: event,
      };
      selected_event_array.push(selected_event_object);
    });
    const set_commisson = await ChangeCommissonAmount();
    const plan_category_ids = inputs?.plan_category_ids?.map((data) => {
      return data?._id;
    });

    if (set_commisson) {
      let formDatas = {
        plan_category_ids: plan_category_ids,
        plan_title: inputs.plan_title,
        detail_button_text: inputs.detail_button_text,
        video_url: inputs.video_url,
        video_description: inputs.video_description,
        extra_coins: inputs.extra_coins,
        subscriber_count: inputs.subscriber_count,
        is_new_user_created_for: inputs.is_new_user_created_for,
        plan_package: inputs.plan_package,
        plan_button_text: inputs.plan_button_text,
        active_campaign_tag_id:
          inputs.active_campaign_tag_id >= 0
            ? inputs.active_campaign_tag_id?.toString()
            : "",
        active_campaign_list_id:
          inputs.active_campaign_list_id >= 0
            ? inputs.active_campaign_list_id?.toString()
            : "",
        plan_status: inputs.plan_status,

        is_plan_free: inputs.is_plan_free,
        short_description: inputs.short_description,
        detailed_description: inputs.detailed_description,
        benefit_description: inputs.benefit_description,
        is_basic_membership: inputs.is_basic_membership,
        plan_for: inputs?.plan_for,
      };
      if (file) {
        formDatas.plan_image = file ? inputs.plan_image : oldImage;
      } else {
        formDatas.plan_image = oldImage;
      }
      if (params && params.page_id) {
        formDatas.created_for = "sale_page";
        formDatas.page_id = params.page_id;
      } else {
        formDatas.created_for = "general";
      }
      if (formType == "EDIT") {
        formDatas.plan_order = inputs.plan_order;
      }
      if (formType == "ADD") {
        formDatas.user_type = inputs?.user_type;
      }

      if (inputs.is_plan_free == false) {
        formDatas.plan_price = inputs.plan_price;
        formDatas.tax = inputs.tax;

        formDatas.stripe_product_name = inputs.stripe_product_name;
        formDatas.plan_currency = inputs.plan_currency;
        formDatas.payment_access = inputs.payment_access;
        if (inputs.payment_access == "recursion") {
          formDatas.product = inputs.product;
          formDatas.days_difference = inputs.days_difference;
          formDatas.first_and_next_recurring_days_diffrence =
            inputs.first_and_next_recurring_days_diffrence;
          formDatas.time_period_interval = inputs.time_period_interval;
          formDatas.trial_period_days = inputs.trial_period_days;
          formDatas.plan_type =
            inputs.plan_type == undefined ? "week" : inputs.plan_type;
          formDatas.initial_amount = inputs.initial_amount;
          formDatas.is_dont_show_full_amount = inputs.is_dont_show_full_amount;
          if (inputs.plan_type == "custom") {
            formDatas.number_of_days =
              inputs.number_of_days == undefined ? 0 : inputs.number_of_days;
          }
        }
      }
      const formObject = formDatas;
      const result =
        formType == "ADD"
          ? await addPaymentPlanApi(formObject)
          : await editPaymentPlanApi(formObject, params.plan_id);
      if (result.code === 200) {
        enqueueSnackbar(result.message, { variant: "success" });
        navigate(-1);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    }
  };
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleChangeOthers = (event, name) => {
    setInputs((values) => ({ ...values, [name]: event }));
  };

  const getPageDetail = async () => {
    const result = await page_detail_by_id(params.page_id);
    if (result.code == 200) {
      setInputs((values) => ({
        ...values,
        user_type: result?.sale_page?.user_type && result?.sale_page?.user_type,
      }));
      handlePageDetail(result.sale_page);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const getPlanDetail = async () => {
    const result = await detailPaymentPlanApi(params.plan_id);
    if (result.code == 200) {
      handleFormatdata(result.payment_plan);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleFormatdata = (data) => {
    setFormType("EDIT");
    setInputs({
      ...data,
      product: data?.product ? data.product : "",
      plan_category_ids: data?.plan_categories,
    });
    let event_array = [];
    data.event.map((item) => {
      event_array.push(item.event_id);
    });
    setEventsName(event_array);
    setIsLoading(false);
  };

  const handlePageDetail = (data) => {
    setPageData(data);

    const get_module_info = data.module_info.filter(
      (item) => item.module_actual_name == module_actual_name,
    )[0];

    setModuleData(get_module_info.module_replica_info);
  };

  useEffect(() => {
    getPlanCategoryList();
    getProgrammes();
    if (params && params.plan_id) {
      if (state) {
        if (params.page_id) {
          handlePageDetail(state.page_info);
        }
        getPlanDetail();
      } else {
        getPlanDetail();
        if (params.page_id) {
          getPageDetail();
        }
      }
    } else {
      setIsLoading(false);
      if (params.page_id) {
        if (state) {
          handlePageDetail(state);
        } else {
          getPageDetail();
        }
      }
    }
    if (formType == "ADD") getPageDetail();
    return () => {
      setFormType("ADD");
    };
  }, []);

  useEffect(() => {
    setOldImage(state?.data?.plan_image);
    let totalValue = inputs.plan_price - inputs.initial_amount;
    let installment = (totalValue / inputs.time_period_interval).toFixed(1);
    setInputs((values) => ({
      ...values,
      ["installment_amount"]:
        !isNaN(installment) && installment !== "Infinity" ? installment : 0,
    }));
  }, [inputs.plan_price, inputs.time_period_interval, inputs.initial_amount]);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container">
      <div className="row mobile-margin display-flex">
        <div className="col-12 display-flex mb-4">
          <IconButton
            className="back-screen-button"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
          <span className="sale-page-title">{pageData.sale_page_title}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          {moduleData?.add_page_heading ? (
            <h2>
              {formType === "ADD"
                ? moduleData.add_page_heading
                : moduleData.edit_page_heading}
            </h2>
          ) : (
            <h2>{`${formType === "ADD" ? "Add" : "Edit"} Plan`}</h2>
          )}
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <TextField
              id="outlined-basic"
              label="Plan Title"
              variant="outlined"
              fullWidth
              required
              name="plan_title"
              value={inputs.plan_title}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <MUIAutocomplete
              inputLabel="Plan Category"
              required={false}
              selectedOption={inputs?.plan_category_ids}
              setSelectedOption={(e) => {
                handleChangeOthers(e, "plan_category_ids");
              }}
              optionsList={planCategoryList}
              autoComplete="new-password"
              name="title"
              multiple
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth required>
              <InputLabel id="demo-simple-select-label">Plan Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="is_plan_free"
                value={inputs.is_plan_free}
                label="Plan Type"
                onChange={handleChange}
              >
                <MenuItem value={true}>Free</MenuItem>
                <MenuItem value={false}>Paid</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth required>
              <InputLabel id="demo-simple-select-label">
                New User Status
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="is_new_user_created_for"
                value={inputs.is_new_user_created_for}
                label="New User Status"
                onChange={handleChange}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth required>
              <InputLabel id="demo-simple-select-label">Plan Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="plan_status"
                value={inputs.plan_status}
                label="Plan Status"
                onChange={handleChange}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth required>
              <InputLabel id="demo-simple-select-label">Plan For</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                disabled
                id="demo-simple-select"
                name="user_type"
                value={inputs.user_type}
                label="Plan For"
                onChange={handleChange}
              >
                <MenuItem value="coach_user">Coach</MenuItem>
                <MenuItem value="member_user">Athlete</MenuItem>
              </Select>
            </FormControl>
          </div>
          {inputs.is_plan_free == false && (
            <>
              <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                <FormControl fullWidth required>
                  <InputLabel id="demo-simple-select-label">
                    Plan Payment
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="payment_access"
                    value={inputs.payment_access}
                    label="Plan Payment"
                    onChange={handleChange}
                  >
                    <MenuItem value="onetime">OneTime</MenuItem>
                    <MenuItem value="recursion">Recurring</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div
                className={`col-lg-6 col-md-6 col-sm-12 mt-4 ${
                  inputs.payment_access == "recursion" ? "d-none" : "d-block"
                }`}
              >
                {renderCurrency()}
              </div>

              <div
                className={`col-lg-6 col-md-6 col-sm-12 mt-4 ${
                  inputs.payment_access == "recursion" ? "d-block" : "d-none"
                }`}
              >
                <FormControl fullWidth required>
                  <InputLabel id="demo-simple-select-label1">
                    Plan Payment Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label1"
                    id="demo-simple-select"
                    name="plan_type"
                    value={inputs.plan_type ? inputs.plan_type : "week"}
                    label="Plan Payment Type"
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value="week">Weekly</MenuItem>
                    <MenuItem value="month">Monthly</MenuItem>
                    <MenuItem value="year">Yearly</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl>
              </div>
              {inputs.plan_type == "custom" && (
                <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                  <TextField
                    id="outlined-basic"
                    label="No of days"
                    variant="outlined"
                    fullWidth
                    required
                    type="number"
                    name="number_of_days"
                    value={inputs.number_of_days}
                    onChange={handleChange}
                  />
                </div>
              )}
              <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                <TextField
                  id="outlined-basic"
                  label="Total Plan Price"
                  variant="outlined"
                  fullWidth
                  required
                  type="number"
                  name="plan_price"
                  value={inputs.plan_price}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                <TextField
                  id="outlined-basic"
                  label="Tax vat %"
                  variant="outlined"
                  fullWidth
                  required
                  type="number"
                  name="tax"
                  value={inputs.tax}
                  onChange={handleChange}
                />
              </div>
              {inputs.payment_access == "recursion" ? (
                <>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Initial Amount"
                      variant="outlined"
                      fullWidth
                      type="number"
                      required
                      name="initial_amount"
                      value={inputs.initial_amount}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Recurring Time Period "
                      variant="outlined"
                      fullWidth
                      required
                      type="number"
                      name="time_period_interval"
                      value={inputs.time_period_interval}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Installment Amount"
                      variant="outlined"
                      fullWidth
                      type="number"
                      required
                      aria-readonly
                      name="installment_amount"
                      value={inputs.installment_amount}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Trial Period Days"
                      variant="outlined"
                      fullWidth
                      name="trial_period_days"
                      value={inputs.trial_period_days}
                      type="number"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                    {renderCurrency()}
                  </div>

                  <div className="col-12">
                    <div className="row"></div>
                  </div>
                  {inputs.first_and_next_recurring_days_diffrence && (
                    <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                      <TextField
                        id="outlined-basic"
                        label="Days Difference"
                        variant="outlined"
                        fullWidth
                        name="days_difference"
                        value={inputs.days_difference}
                        type="number"
                        onChange={handleChange}
                      />
                    </div>
                  )}
                </>
              ) : (
                <></>
              )}
            </>
          )}

          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <TextField
              id="outlined-basic"
              label="Plan Button Text"
              variant="outlined"
              fullWidth
              required
              name="plan_button_text"
              value={inputs.plan_button_text}
              onChange={handleChange}
            />
          </div>

          {formType === "EDIT" && (
            <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
              <TextField
                id="outlined-basic"
                label="Plan Order"
                variant="outlined"
                fullWidth
                required
                type="number"
                name="plan_order"
                value={inputs.plan_order}
                onChange={handleChange}
              />
            </div>
          )}
          {inputs.is_plan_free == false && (
            <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
              <TextField
                id="outlined-basic"
                label="Stripe Product Name"
                variant="outlined"
                fullWidth
                required
                name="stripe_product_name"
                value={inputs.stripe_product_name}
                onChange={handleChange}
              />
            </div>
          )}
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <TextField
              id="outlined-basic"
              label="Details Button Text"
              variant="outlined"
              fullWidth
              required
              name="detail_button_text"
              value={inputs.detail_button_text}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <TextField
              id="outlined-basic"
              label="Video Url"
              variant="outlined"
              fullWidth
              required
              name="video_url"
              value={inputs.video_url}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
            <div className="row w-100 div-style ms-0 pt-0">
              <div className="col-5">
                <p className="">Plan Image </p>
                <FormHelperText className="pt-0">
                  Image Size(1000 X 670) ("JPG", "JPEG", "PNG","WEBP")
                </FormHelperText>
              </div>
              <div className="col-3">
                <div className="col-3">
                  {file ? (
                    <img className="image-border" src={file} height="70" />
                  ) : (
                    oldImage && (
                      <img
                        className="image-border"
                        src={s3baseUrl + oldImage}
                        height="70"
                      />
                    )
                  )}
                </div>
              </div>
              <div className="col-4 text-end pt-2">
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    name="plan_image"
                    onChange={fileChangedHandler}
                  />

                  <Button
                    className="small-contained-button"
                    startIcon={<FileUploadIcon />}
                    component="span"
                  >
                    Upload
                  </Button>
                </label>
              </div>
            </div>
          </div>
          {inputs.is_plan_free == false &&
            inputs.payment_access == "recursion" && (
              <div className="col-12 mt-4">
                <FormControl fullWidth required>
                  <InputLabel id="demo-simple-select-label">Product</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="product"
                    value={inputs.product}
                    label="product"
                    onChange={handleChange}
                  >
                    {products.map((product) => {
                      return (
                        <MenuItem value={product._id}>{product.name}</MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
            )}
          <div className="col-12 mt-4">
            <h4> Description *</h4>
            <GeneralCkeditor
              setInputs={setInputs}
              inputs={inputs}
              name="detailed_description"
              editorHeight={320}
            />
          </div>
          <div className="col-12 mt-4">
            <h4>Plan Package</h4>
            <GeneralCkeditor
              setInputs={setInputs}
              inputs={inputs}
              name="plan_package"
              editorHeight={320}
            />
          </div>
          <div className="col-12 mt-4">
            <h4>Video Description</h4>
            <GeneralCkeditor
              setInputs={setInputs}
              inputs={inputs}
              name="video_description"
              editorHeight={320}
            />
          </div>
          <div className="text-end mt-4">
            <button className="small-contained-button">
              {formType == "ADD" ? "Submit" : "Update"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
